export default "__VITE_ASSET__OysdAcwA__"